module.exports = __webpack_public_path__ + "img/awards@2x.e8bf1d4.jpg";